/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_SubtitleInputs */

const he_contact_subtitle = /** @type {(inputs: Contact_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יש לך שאלה או הצעה? נשמח לשמוע ממך`)
};

const en_contact_subtitle = /** @type {(inputs: Contact_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Have a question or suggestion? We'd love to hear from you`)
};

/**
* | output |
* | --- |
* | "Have a question or suggestion? We'd love to hear from you" |
*
* @param {Contact_SubtitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_subtitle = /** @type {((inputs?: Contact_SubtitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_SubtitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_subtitle(inputs)
	return en_contact_subtitle(inputs)
});